import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { contentsAPI } from '@/utils/contentsApi';
import { bannerTypes } from '@/constants/types';
import Button from '@/app/components/Button';
import { useSelector } from 'react-redux';
import DynamicSectionTitle from '../Typography/DynamicSectionTitle';
import SafeHTML from '../Typography/SafeHTML';
import ButtonLabel from '../Typography/ButtonLabel';
import SingleBannerCarouselSkeleton from '../Skeleton/SingleBannerCarouselSkeleton';
import BannerImageComponent from '../Image/BannerImageComponent';

function SingleBannerCarousel({ section }) {
  const router = useRouter();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { lang: selectLang } = useSelector((state) => state.globalSettings);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const contentsData = {
          sectionId: section?.id,
          contentType: section?.content_type,
        };
        const response = await contentsAPI(contentsData);
        setData([...response]);
        setLoading(false);
      } catch (err) {
        console.warn('Error fetching data:', err);
      }
    };

    setLoading(true);
    fetchData();
  }, [section]);

  return (
    <div className="single-banner-carousel container 3xl:max-w-[1440px] mx-auto">
      <div className="mb-24 md:mb-[40px]">
        <div className="flex flex-col lg:flex-row shadow-compare-bottom-action rounded-xl lg:rounded-[24px] overflow-hidden w-full h-full lg:h-[621px] xl:h-[653px] 3xl:h-[720px] 3xl:max-w-[1400px] mx-auto">
          {loading ? (
            <SingleBannerCarouselSkeleton />
          ) : (
            <>
              <div className="w-full lg:w-[66.77%] relative">
                {Array.isArray(data) && data?.length > 0 ? (
                  <BannerImageComponent
                    desktopSrc={data[0]?.image?.large}
                    mobileSrc={data[0]?.image?.small}
                    type={bannerTypes.singleBannerCarousel}
                    alt={data?.title?.en ?? 'Single Banner Carousel'}
                  />
                ) : null}
                <div className="block lg:hidden h-[22px] absolute bottom-0 left-0 right-0 z-50 bg-home-appliance-mobile" />
              </div>

              <div className="w-full lg:w-[33.23%] bg-gunmetal flex flex-col justify-center items-center px-[16px] py-[24px]">
                <DynamicSectionTitle
                  text={section?.title[selectLang] ?? section?.title?.en}
                  className="text-center text-heart-of-ice mb-6 lg:mb-8"
                />

                <SafeHTML
                  html={
                    section?.description[selectLang] ?? section?.description?.en
                  }
                  className="font-encode-sans text-sm lg:text-lg text-center mb-20 text-heart-of-ice"
                />

                <Link
                  prefetch={false}
                  aria-label="Go to section redirect URL"
                  href={section?.redirect_url?.en?.url ?? ''}
                >
                  <Button
                    type="primary"
                    className="!h-[24px] lg:!h-[36px] !bg-white border !border-himalayan-poppy !px-16 !py-4 lg:!py-10 hover:!bg-placebo-green"
                    onClick={() => router.push(section?.redirect_url?.en?.url)}
                  >
                    <ButtonLabel
                      label={section?.redirect_url?.en?.text}
                      className="text-xs lg:text-sm text-senate font-semibold lg:font-bold"
                    />
                  </Button>
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default SingleBannerCarousel;
